import { useUser } from "@/lib/hooks/use-user";
import { UserRole } from "@/lib/interfaces/user";
import Preloader from "@/ui-components/ui/preloader";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const Settings = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
    if (!user) return;
    if (user.role === UserRole.Admin || user.role === UserRole.SuperAdmin) {
      navigate("/settings/products");
    } else {
      navigate("/personal");
    }
  }, [navigate, user]);

  return <Preloader />;
};

export default Settings;
